import React from 'react';
import StoryblokClient from "storyblok-js-client";

import LinkCtaButton from "../components/widgets/linkCtaButton/LinkCTAButton";
import SolidCtaButton from "../components/widgets/solidCtaButton/SolidCtaButton";
import TransparentCTAButton from "../components/widgets/transparentCtaButton/TransparentCTAButton";
import LinkCTAModal from "../components/widgets/linkCTAModal/LinkCTAModal";

import config from '../../gatsby-config'
import { MARK_LINK, render } from "storyblok-rich-text-react-renderer"
import Link from './link';


const sbConfig = config.plugins.find((item) => item.resolve === 'gatsby-source-storyblok')


const Storyblok = new StoryblokClient({
  accessToken: sbConfig.options.accessToken,
  cache: {
    clear: "auto",
    type: "memory",
  },
});


export function resolveRichText(sourceRichTextData) {
  if (sourceRichTextData) {
    return { __html: Storyblok.richTextResolver.render(sourceRichTextData) };
  } else {
    return { __html: "" };
  }
}

//Use for richtext that has components
export function resolveRichTextWithComponents(sourceRichTextData) {
  if (sourceRichTextData) {
    return render(sourceRichTextData, {
      blokResolvers: {
        link_cta: (props) => {
          let buttonProps = handleButtonProps(props);
          return (<LinkCtaButton buttonProps={buttonProps} withClass="richtext-inline-button" />)
        },
        linked_cta: (props) => {
          let buttonProps = handleButtonProps(props);
          return (<LinkCtaButton buttonProps={buttonProps} withClass="richtext-inline-button" />)
        },
        solid_cta: (props) => {
          let buttonProps = handleButtonProps(props);
          return (<SolidCtaButton buttonProps={buttonProps} />)
        },
        transparent_cta: (props) => {
          let buttonProps = handleButtonProps(props);
          return (<TransparentCTAButton buttonProps={buttonProps} />)
        },
        link_cta_modal: (props) => {
          let buttonProps = handleButtonProps(props);
          return (<LinkCTAModal buttonProps={buttonProps} withClass="richtext-inline-button" />)
        }
      },
      markResolvers: {
        [MARK_LINK]: (children, storyblokLinkObject)=>{
          return <Link storyblok_richtext_link={storyblokLinkObject}>{children}</Link>;
        } 
      }
    });
  } else {
    return "";
  }
}

function handleButtonProps(props) {
  const buttonProps = {
    text: props.text,
    url: props.cta_link,
    textColor: props.cta_color,
    isModal: props.is_modal,
    modalId: props.modal_id,
    modal: props.modal,
    component: props.component
  };
  return buttonProps
}
